import React, { useState } from "react";
import Slider from "react-slick"; // Advanced carousel library

const Cards = () => {
  const [isHovered, setIsHovered] = useState(false);
  const cards = [
    {
      id: 1,
      image: "./../assets/images/new_about_us/nxatel_values/icon1.svg",
      title: "Never let the customer down",
      description:
        "We prioritize customer satisfaction through proactive and reliable service.",
    },
    {
      id: 2,
      image: "./../assets/images/new_about_us/nxatel_values/icon2.svg",
      title: "Extraordinary in everything we do",
      description: "We go beyond expectations to deliver excellence.",
    },
    {
      id: 3,
      image: "./../assets/images/new_about_us/nxatel_values/icon3.svg",
      title: "All in, accountable, and hungry to succeed",
      description: "We take ownership of our work and drive success.",
    },
    {
      id: 4,
      image: "./../assets/images/new_about_us/nxatel_values/icon4.svg",
      title: "Trustworthy and transparent",
      description:
        "Build trust by being honest, clear, and dependable in all interactions.",
    },
    {
      id: 5,
      image: "./../assets/images/new_about_us/nxatel_values/icon5.svg",
      title: "Excellence in everything we do",
      description: "Deliver superior quality and performance consistently.",
    },
    {
      id: 6,
      image: "./../assets/images/new_about_us/nxatel_values/icon6.svg",
      title: "Love learning and staying curious",
      description:
        "Foster a culture of continuous improvement through curiosity and education.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 4000,
    slidesToShow: 3, // Show 3 cards on larger screens
    slidesToScroll: 1, // Scroll 3 cards at a time
    autoplay: !isHovered, // Autoplay is controlled by hover state
    autoplaySpeed: 3000, // Change the speed of autoplay (3 seconds)
    cssEase: "ease-in-out",
    responsive: [
      {
        breakpoint: 1024, // For tablets
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // For mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {cards.map((card) => (
          <div key={card.id} className="card">
            <img src={card.image} alt={card.title} className="card-image" />
            <h2 className="card-title">{card.title}</h2>
            <p className="card-description">{card.description}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Cards;
